import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AuthSessionFailureDialogComponent } from './auth-session-failure-dialog.component';
import { AuthSignInFailureDialogComponent } from './auth-signin-failure-dialog.component';
import { AuthEffects } from './auth.effects';
import { AuthCoreModule } from './core/auth-core.module';
import { CustomAuthModule } from './custom/custom-auth.module';

export function noop(effects?: AuthEffects) {
  return () => {
    console.debug('noop AuthEffects');
  };
}

@NgModule({
  providers: [
    AuthEffects,
    provideAppInitializer(() => {
        const initializerFn = (noop)(inject(AuthEffects));
        return initializerFn();
      }),
  ],
  declarations: [AuthSessionFailureDialogComponent, AuthSignInFailureDialogComponent],
  imports: [CommonModule, AuthCoreModule, CustomAuthModule, MatButtonModule, MatDialogModule, MatIconModule, TranslateModule],
})
export class AuthModule { }
